import Filter from 'uikit/dist/js/components/filter'

export default function () {
    UIkit.component('filter', Filter)
}
